import React from "react";
import RuleBodyPage from "components/common/RuleBodyPage";
import { RuleModalBodyProps } from "components/common/RuleModal";
import { useTranslation } from "react-i18next";

/**
 * 역할 룰렛 게임 규칙 설명
 */
const RoleDistributorRuleBody: React.FC<RuleModalBodyProps> = ({ page }) => {
  const { t } = useTranslation();
  const rules = t("RoleDistributor.rules", { returnObjects: true }) as string[];

  const phaseContainer =
    "flex items-center gap-3 p-3 bg-gray-800 rounded-lg mb-4";
  const iconContainer =
    "w-8 h-8 min-w-9 min-h-9 flex items-center justify-center rounded-full text-sm";

  return (
    <div className="relative flex">
      {/* Page 1: 게임 소개 및 기본 규칙 */}
      <RuleBodyPage show={page === 0}>
        {/* <div className="text-xl font-bold text-indigo-400 mb-4">
          역할 룰렛
        </div> */}
        <div className="space-y-4">
          <div className="text-gray-100">{rules[0]}</div>
          {/* <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-indigo-600`}>
              <i className="fas fa-crown" />
            </div>
            <div>
              <div className="font-medium text-indigo-300 mb-1">{rules[1]}</div>
              <div className="text-sm text-gray-300">{rules[2]}</div>
            </div>
          </div>
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-blue-600`}>
              <i className="fas fa-users" />
            </div>
            <div>
              <div className="font-medium text-blue-300 mb-1">{rules[3]}</div>
              <div className="text-sm text-gray-300">{rules[4]}</div>
            </div>
          </div> */}
          {/* Usage Tips */}
          <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
            <div className="font-medium text-indigo-300 mb-2">{rules[24]}</div>
            <ul className="list-disc list-inside space-y-2 text-sm text-gray-300">
              <div>{rules[25]}</div>
              <li>{rules[26]}</li>
              <li>{rules[27]}</li>
              <li>{rules[28]}</li>
              <li>{rules[29]}</li>
              <li>{rules[30]}</li>
              <div className="text-xs text-yellow-400">{rules[31]}</div>
            </ul>
          </div>
        </div>
      </RuleBodyPage>

      {/* Page 2: 역할 시스템 */}
      <RuleBodyPage show={page === 1}>
        <div className="space-y-4">
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-green-600`}>
              <i className="fas fa-home" />
            </div>
            <div>
              <div className="font-medium text-green-300 mb-1">{rules[5]}</div>
              <div className="text-sm text-gray-300">{rules[6]}</div>
            </div>
          </div>
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-purple-600`}>
              <i className="fas fa-plus-circle" />
            </div>
            <div>
              <div className="font-medium text-purple-300 mb-1">{rules[7]}</div>
              <div className="text-sm text-gray-300">{rules[8]}</div>
            </div>
          </div>
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-yellow-600`}>
              <i className="fas fa-random" />
            </div>
            <div>
              <div className="font-medium text-yellow-300 mb-1">{rules[9]}</div>
              <div className="text-sm text-gray-300">{rules[10]}</div>
            </div>
          </div>
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-amber-600`}>
              <i className="fas fa-eye" />
            </div>
            <div>
              <div className="font-medium text-amber-300 mb-1">{rules[12]}</div>
              <div className="text-sm text-gray-300">{rules[13]}</div>
            </div>
          </div>
        </div>
      </RuleBodyPage>

      {/* Page 3: 능력 시스템 */}
      <RuleBodyPage show={page === 2}>
        <div className="space-y-4">
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-violet-600`}>
              <i className="fas fa-bolt" />
            </div>
            <div>
              <div className="font-medium text-violet-300 mb-1">
                {rules[14]}
              </div>
              <div className="text-sm text-gray-300">{rules[15]}</div>
            </div>
          </div>

          <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
            <div className="space-y-2">
              {/* 암살 */}
              <div className="flex items-center gap-3 p-2 bg-gray-700/50 rounded-lg">
                <div className="text-lg flex-shrink-0">🗡️</div>
                <div className="flex-1">
                  <div className="text-white font-medium text-sm">
                    {rules[17]}
                  </div>
                </div>
              </div>

              {/* 보호 */}
              <div className="flex items-center gap-3 p-2 bg-gray-700/50 rounded-lg">
                <div className="text-lg flex-shrink-0">🛡️</div>
                <div className="flex-1">
                  <div className="text-white font-medium text-sm">
                    {rules[18]}
                  </div>
                </div>
              </div>

              {/* 조사 */}
              <div className="flex items-center gap-3 p-2 bg-gray-700/50 rounded-lg">
                <div className="text-lg flex-shrink-0">🔍</div>
                <div className="flex-1">
                  <div className="text-white font-medium text-sm">
                    {rules[19]}
                  </div>
                </div>
              </div>

              {/* 공개 지목 */}
              <div className="flex items-center gap-3 p-2 bg-gray-700/50 rounded-lg">
                <div className="text-lg flex-shrink-0">👉</div>
                <div className="flex-1">
                  <div className="text-white font-medium text-sm">
                    {rules[20]}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </RuleBodyPage>

      {/* Page 4: 나머지 능력들 및 활용 팁 */}
      <RuleBodyPage show={page === 3}>
        <div className="space-y-4">
          <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
            <div className="space-y-2">
              {/* 투표 */}
              <div className="flex items-center gap-3 p-2 bg-gray-700/50 rounded-lg">
                <div className="text-lg flex-shrink-0">🗳️</div>
                <div className="flex-1">
                  <div className="text-white font-medium text-sm">
                    {rules[21]}
                  </div>
                </div>
              </div>

              {/* 공개 찬반투표 */}
              <div className="flex items-center gap-3 p-2 bg-gray-700/50 rounded-lg">
                <div className="text-lg flex-shrink-0">👍</div>
                <div className="flex-1">
                  <div className="text-white font-medium text-sm">
                    {rules[22]}
                  </div>
                </div>
              </div>

              {/* 비공개 찬반투표 */}
              <div className="flex items-center gap-3 p-2 bg-gray-700/50 rounded-lg">
                <div className="text-lg flex-shrink-0">🔒</div>
                <div className="flex-1">
                  <div className="text-white font-medium text-sm">
                    {rules[23]}
                  </div>
                </div>
              </div>

              {/* 역할 확인 */}
              <div className="flex items-center gap-3 p-2 bg-gray-700/50 rounded-lg">
                <div className="text-lg flex-shrink-0">👁️</div>
                <div className="flex-1">
                  <div className="text-white font-medium text-sm">
                    {rules[89]}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </RuleBodyPage>

      {/* Page 5: Avalon Guide */}
      <RuleBodyPage show={page === 4}>
        <div className="space-y-4">
          <h3 className="text-xl font-bold text-purple-400 mb-4">{rules[32]}</h3>

          <div className="text-gray-100">{rules[33]}</div>

          {/* Game Overview */}
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-indigo-600`}>
              <i className="fas fa-info-circle" />
            </div>
            <div>
              <div className="font-medium text-indigo-300 mb-1">{rules[34]}</div>
              <div className="text-sm text-gray-300">{rules[35]}</div>
            </div>
          </div>

          {/* Good Faction */}
          <div className="bg-blue-900/20 border border-blue-700/30 p-4 rounded-lg">
            <h4 className="text-blue-300 font-semibold mb-3">{rules[36]}</h4>

            <div className="space-y-2">
              {/* Merlin */}
              <div className={`${phaseContainer} mb-2`}>
                <div className={`${iconContainer} bg-blue-600`}>
                  <span className="text-lg">🔮</span>
                </div>
                <div>
                  <div className="font-medium text-blue-300 mb-1">{rules[37]}</div>
                  <div className="text-sm text-gray-300">{rules[38]}</div>
                </div>
              </div>

              {/* Percival */}
              <div className={`${phaseContainer} mb-2`}>
                <div className={`${iconContainer} bg-blue-500`}>
                  <span className="text-lg">🛡️</span>
                </div>
                <div>
                  <div className="font-medium text-blue-300 mb-1">{rules[39]}</div>
                  <div className="text-sm text-gray-300">{rules[40]}</div>
                </div>
              </div>

              {/* Loyal Servant */}
              <div className={`${phaseContainer}`}>
                <div className={`${iconContainer} bg-blue-400`}>
                  <span className="text-lg">⚔️</span>
                </div>
                <div>
                  <div className="font-medium text-blue-300 mb-1">{rules[41]}</div>
                  <div className="text-sm text-gray-300">{rules[42]}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Evil Faction */}
          <div className="bg-red-900/20 border border-red-700/30 p-4 rounded-lg">
            <h4 className="text-red-300 font-semibold mb-3">{rules[43]}</h4>

            <div className="space-y-2">
              {/* Mordred */}
              <div className={`${phaseContainer} mb-2`}>
                <div className={`${iconContainer} bg-red-600`}>
                  <span className="text-lg">🗡️</span>
                </div>
                <div>
                  <div className="font-medium text-red-300 mb-1">{rules[44]}</div>
                  <div className="text-sm text-gray-300">{rules[45]}</div>
                </div>
              </div>

              {/* Morgana */}
              <div className={`${phaseContainer} mb-2`}>
                <div className={`${iconContainer} bg-red-500`}>
                  <span className="text-lg">🔮</span>
                </div>
                <div>
                  <div className="font-medium text-red-300 mb-1">{rules[46]}</div>
                  <div className="text-sm text-gray-300">{rules[47]}</div>
                </div>
              </div>

              {/* Assassin */}
              <div className={`${phaseContainer} mb-2`}>
                <div className={`${iconContainer} bg-red-700`}>
                  <span className="text-lg">🗡️</span>
                </div>
                <div>
                  <div className="font-medium text-red-300 mb-1">{rules[48]}</div>
                  <div className="text-sm text-gray-300">{rules[49]}</div>
                </div>
              </div>

              {/* Oberon */}
              <div className={`${phaseContainer} mb-2`}>
                <div className={`${iconContainer} bg-red-400`}>
                  <span className="text-lg">👤</span>
                </div>
                <div>
                  <div className="font-medium text-red-300 mb-1">{rules[50]}</div>
                  <div className="text-sm text-gray-300">{rules[51]}</div>
                </div>
              </div>

              {/* Minion */}
              <div className={`${phaseContainer}`}>
                <div className={`${iconContainer} bg-red-300`}>
                  <span className="text-lg">⚔️</span>
                </div>
                <div>
                  <div className="font-medium text-red-300 mb-1">{rules[52]}</div>
                  <div className="text-sm text-gray-300">{rules[53]}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Action Usage */}
          <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
            <h4 className="text-green-300 font-semibold mb-2">{rules[54]}</h4>
            <ol className="list-decimal list-inside space-y-2 text-sm text-gray-300">
              <li>{rules[55]}</li>
              <li>{rules[56]}</li>
              <li>{rules[57]}</li>
              <li>{rules[58]}</li>
            </ol>
          </div>

          {/* Recommended Setup */}
          <div className="bg-green-900/20 border border-green-700/30 p-4 rounded-lg">
            <h4 className="text-green-300 font-semibold mb-2">{rules[59]}</h4>
            <ul className="space-y-1 text-sm text-gray-300">
              <li>• {rules[60]}</li>
              <li>• {rules[61]}</li>
              <li>• {rules[62]}</li>
              <li>• {rules[63]}</li>
            </ul>
          </div>
        </div>
      </RuleBodyPage>

      {/* Page 6: Mafia Guide */}
      <RuleBodyPage show={page === 5}>
        <div className="space-y-4">
          <h3 className="text-xl font-bold text-red-400 mb-4">{rules[64]}</h3>

          <div className="text-gray-100">{rules[65]}</div>

          {/* Game Overview */}
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-indigo-600`}>
              <i className="fas fa-info-circle" />
            </div>
            <div>
              <div className="font-medium text-indigo-300 mb-1">{rules[66]}</div>
              <div className="text-sm text-gray-300">{rules[67]}</div>
            </div>
          </div>

          {/* Citizen Faction */}
          <div className="bg-green-900/20 border border-green-700/30 p-4 rounded-lg">
            <h4 className="text-green-300 font-semibold mb-3">{rules[68]}</h4>

            <div className="space-y-2">
              {/* Citizen */}
              <div className={`${phaseContainer} mb-2`}>
                <div className={`${iconContainer} bg-green-600`}>
                  <span className="text-lg">👤</span>
                </div>
                <div>
                  <div className="font-medium text-green-300 mb-1">{rules[69]}</div>
                  <div className="text-sm text-gray-300">{rules[70]}</div>
                </div>
              </div>

              {/* Police */}
              <div className={`${phaseContainer} mb-2`}>
                <div className={`${iconContainer} bg-blue-600`}>
                  <span className="text-lg">👮</span>
                </div>
                <div>
                  <div className="font-medium text-blue-300 mb-1">{rules[71]}</div>
                  <div className="text-sm text-gray-300">{rules[72]}</div>
                </div>
              </div>

              {/* Doctor */}
              <div className={`${phaseContainer}`}>
                <div className={`${iconContainer} bg-cyan-600`}>
                  <span className="text-lg">💉</span>
                </div>
                <div>
                  <div className="font-medium text-cyan-300 mb-1">{rules[73]}</div>
                  <div className="text-sm text-gray-300">{rules[74]}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Mafia Faction */}
          <div className="bg-red-900/20 border border-red-700/30 p-4 rounded-lg">
            <h4 className="text-red-300 font-semibold mb-3">{rules[75]}</h4>

            <div className={`${phaseContainer}`}>
              <div className={`${iconContainer} bg-red-600`}>
                <span className="text-lg">🔫</span>
              </div>
              <div>
                <div className="font-medium text-red-300 mb-1">{rules[76]}</div>
                <div className="text-sm text-gray-300">{rules[77]}</div>
              </div>
            </div>
          </div>

          {/* Gameplay Flow */}
          <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
            <h4 className="text-purple-300 font-semibold mb-2">{rules[78]}</h4>
            <ol className="list-decimal list-inside space-y-2 text-sm text-gray-300">
              <li>{rules[79]}</li>
              <li>{rules[80]}</li>
              <li>{rules[81]}</li>
            </ol>
          </div>

          {/* Action System Usage */}
          <div className="bg-violet-900/20 border border-violet-700/30 p-4 rounded-lg">
            <h4 className="text-violet-300 font-semibold mb-2">{rules[82]}</h4>
            <ul className="space-y-1 text-sm text-gray-300">
              <li>• {rules[83]}</li>
              <li>• {rules[84]}</li>
            </ul>
          </div>

          {/* Recommended Setup */}
          <div className="bg-green-900/20 border border-green-700/30 p-4 rounded-lg">
            <h4 className="text-green-300 font-semibold mb-2">{rules[85]}</h4>
            <ul className="space-y-1 text-sm text-gray-300">
              <li>• {rules[86]}</li>
              <li>• {rules[87]}</li>
              <li>• {rules[88]}</li>
            </ul>
          </div>
        </div>
      </RuleBodyPage>
    </div>
  );
};

export default RoleDistributorRuleBody;
